import React from "react";

export type CampoProps = {
  etiqueta: string;
  errores?: string[];
  ayuda?: string;
  requerido?: boolean;
  className?: string;
  children: React.ReactNode;
};

export default function Campo({
  etiqueta,
  errores,
  ayuda,
  requerido,
  className = "",
  children,
}: CampoProps) {
  return (
    <label className={`campo ${errores?.length ? "con-error" : ""} ${className}`.trim()}>
      <span className="campo-etiqueta">
        {etiqueta}
        {requerido && <span aria-hidden="true"> *</span>}
      </span>
      {children}
      {ayuda && !errores?.length && <span className="campo-ayuda">{ayuda}</span>}
      {errores?.map((e) => (
        <span key={e} className="campo-error">
          {e}
        </span>
      ))}
    </label>
  );
}
